import { useLocation } from './router.ts';
import { Home } from './pages/home.tsx';
import { GamePage } from './pages/game.tsx';
import { linkFromRoute } from '../shared/links.ts';
import { Legal } from './pages/legal.tsx';

export function App() {
  const loc = useLocation();
  const link = linkFromRoute(loc.pathname, loc.search);
  if (loc.pathname === '/legal') return <Legal />;
  if (link) return <GamePage key={loc.pathname + loc.search} link={link} />;
  return <Home />;
}
